import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';
import { resolve } from 'api/resolve';
import { useProposalContext } from 'features/project-versioning/hooks/useProposalContext';

import { useProposalApi } from '../proposal-api';

export function useGetCurrentProposal() {
  const { projectId, proposalId } = useProposalContext();
  const { getProposal } = useProposalApi();
  const { PROPOSAL } = QUERY_KEYS;

  return useQuery({
    queryKey: [PROPOSAL, projectId, proposalId],
    queryFn: () => resolve(getProposal(projectId!, proposalId!)),
    enabled: !!projectId && !!proposalId
  });
}
